var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProject = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M160 35v40c0 13.807 11.193 25 25 25h40v125c0 10.93-8.769 19.813-19.656 19.997L205 245h-64.545l-.455-.533-.455.533H75c-11.046 0-20-8.954-20-20V55c0-11.045 8.954-20 20-20zm15 0 50 50h-40c-5.523 0-10-4.477-10-10z"
})));
export default SvgProject;